import styles from './PlayersPanel.module.css'
import { useMemorama } from '../../context/MemoramaContext'
import { useLanguage } from '@context/LanguageContext'
import { PlayerStatus } from '@shared'

/**
 * Memorama-specific players panel.
 * Displays all players with their scores during gameplay.
 * Highlights the current active player.
 */
function PlayersPanel () {
  const { players, currentTurnIndex } = useMemorama()
  const { t } = useLanguage()

  if (!players.length) return null

  return (
    <aside
      className={styles.playersPanel}
      role='complementary'
      aria-label={t.shared.access.player.panel}
    >
      {players.map((player, index) => (
        <PlayerStatus
          key={player.id}
          player={player}
          isActive={index === currentTurnIndex}
          avatarAlt={t.shared.access.player.avatarAlt.replace('{name}', player.name)}
          statSuffix='pts'
          statAriaLabel={`${player.score} ${t.shared.access.player.points}`}
        />
      ))}
    </aside>
  )
}

export default PlayersPanel
